export class AppConstants {
    static API_URL = 'https://bees.langpower.email';
    static CHUNK_MAXLENGTH = 250;
}
